import * as React from "react";

type Lang = "en-US" | "de-CH";
type Ctx = { lang: Lang; setLang: (l: Lang) => void };

// Provide a default (SSR-safe) context value
const defaultCtx: Ctx = { lang: "en-US", setLang: () => {} };

const LanguageContext = React.createContext<Ctx | null>(defaultCtx);

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLang] = React.useState<Lang>("en-US");

  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    const saved = window.localStorage.getItem("lang");
    if (saved === "de-CH" || saved === "en-US") setLang(saved as Lang);
    setReady(true);
  }, []);

  React.useEffect(() => {
    if (ready) window.localStorage.setItem("lang", lang);
  }, [lang, ready]);

  const value = React.useMemo(() => ({ lang, setLang, ready }), [lang, ready]);
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  // returns defaultCtx during SSR
  return React.useContext(LanguageContext);
}
